import React, {ReactElement} from 'react';
import {Card, CardContent, makeStyles} from '@material-ui/core';
import {APP} from '../../../../../../style/variable';
import {useTranslation} from 'react-i18next';
import PreviousPaymentPlanHistoryCard from './../PreviousPaymentPlanDetailsCard/PreviousPaymentPlanHistoryCard';

const PreviousPaymentPlanDetailsCardStyles = makeStyles(() => ({
  root: {
    minWidth: 275
  },
  DetailsView: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1rem',
    rowGap: '1rem',
    overflowY: 'auto',
    maxHeight: '30rem'
  },
  previousPaymentPlanMainView: {
    flexDirection: 'row',
    display: 'flex'
  },
  previousPaymentPlanHeaderValue: {
    color: APP.STATUS.DEFAULT,
    fontSize: '1rem'
  },
  NoPreviousPaymentPlanInfoView: {
    flexDirection: 'row',
    display: 'flex'
  },
  divider: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem'
  },
  cardRoot: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '13px'
    }
  },
  previousPlanPaddingBottom: {
    paddingBottom: '10px'
  }
}));

interface PreviousPaymentPlanDetailsCardProps {
  completedPlanDetails: Array<any>;
  cancelledPlanDetails: Array<any>;
  totalPaidAmount: number;
  isConvenienceFeeExist?: any;
  isGuarantorPortal: any;
  forceUpdateHandler(): void;
}
const PreviousPaymentPlanDetailsCard = (
  props: PreviousPaymentPlanDetailsCardProps
): ReactElement => {
  const classes = PreviousPaymentPlanDetailsCardStyles();
  const {
    completedPlanDetails,
    cancelledPlanDetails,
    isConvenienceFeeExist,
    isGuarantorPortal,
    forceUpdateHandler
  } = props;
  const {t} = useTranslation();

  const renderPreviousPaymentPlanData = (data: any): ReactElement => {
    return (
      <div className={classes.previousPlanPaddingBottom}>
        {data?.map((item: any, index: number) => {
          return (
            <PreviousPaymentPlanHistoryCard
              item={item}
              totalPaidAmount={item?.paidInstallmentsTotalAmount}
              key={index}
              index={index}
              isConvenienceFeeExist={isConvenienceFeeExist}
              isGuarantorPortal={isGuarantorPortal}
              forceUpdateHandler={forceUpdateHandler}
            />
          );
        })}
      </div>
    );
  };
  const renderPreviousPaymentPlanDetails = (): ReactElement => {
    const allPreviousPlans = [...completedPlanDetails, ...cancelledPlanDetails];
    allPreviousPlans.sort((a, b) => {
      return b.id - a.id;
    });
    return (
      <div>
        {/* <Divider className={classes.divider} /> */}
        {renderPreviousPaymentPlanData(allPreviousPlans)}
      </div>
    );
  };

  const renderNoPreviousPaymentPlanDetailsInfo = (): ReactElement => {
    return (
      <div className={classes.NoPreviousPaymentPlanInfoView}>
        <span className={classes.previousPaymentPlanHeaderValue}>
          {t('PAYMENT_PLANS.NO_PREVIOUS_PLANS')}
        </span>
      </div>
    );
  };
  return (
    <div>
      {completedPlanDetails?.length > 0 || cancelledPlanDetails?.length > 0 ? (
        <div className={classes.DetailsView}>
          {renderPreviousPaymentPlanDetails()}
        </div>
      ) : (
        <Card className={classes.cardRoot}>
          <CardContent>{renderNoPreviousPaymentPlanDetailsInfo()}</CardContent>
        </Card>
      )}
    </div>
  );
};
export default PreviousPaymentPlanDetailsCard;
